import { DealType, IncentiveType } from '@makemydeal/dr-shared-bff-types';

export const REQUEST_PROPOSAL = '/showroom/request-proposal';

// Deal Summary Routes - relative paths (base route comes from props)
export const DEAL_SUMMARY_REQUEST_QUOTE = '/request-quote';
export const DEAL_SUMMARY_QUOTE_REQUESTED = '/quote-requested';
export const DEAL_SUMMARY_VIEW_QUOTE = '/view-quote';
export const DEAL_SUMMARY_ACCEPTED_DEAL = '/accepted-deal';
export const DEAL_SUMMARY_DEAL_PROPOSAL = '/deal-proposal';

export const INCENTIVE_LABELS: Record<IncentiveType, string> = {
    [IncentiveType.StudentRecentGraduate]: 'Student/Recent Grad',
    [IncentiveType.MilitaryVeteran]: 'Military/Veteran',
    [IncentiveType.FirstResponder]: 'First Responder',
    [IncentiveType.PrivateOffer]: 'Private Offer',
    [IncentiveType.Loyalty]: 'Loyalty',
    [IncentiveType.Conquest]: 'Conquest'
};

export const INCENTIVE_TYPES = Object.values(IncentiveType);

export const DEAL_TYPE_LABELS: Record<DealType, string> = {
    [DealType.Finance]: 'Finance',
    [DealType.Lease]: 'Lease',
    [DealType.Cash]: 'Cash'
};

export const DEAL_TYPES = Object.values(DealType);

export const MAX_COMMENT_LENGTH = 500;

export const CO_BUYER_PREFIX = 'Co-Buyer:';

export const VEHICLE_SPEC_LABELS = {
    MSRP: 'MSRP',
    VIN: 'VIN',
    STOCK: 'Stock #',
    COLOR: 'Color',
    MILEAGE: 'Mileage',
    FUEL_ECONOMY: 'Fuel Economy',
    ENGINE: 'Engine'
} as const;

export const FUEL_ECONOMY_LABELS = {
    NEW_AVG: 'New Avg Fuel Economy',
    TRADE_AVG: 'Trade Avg Fuel Economy',
    AVG_MONTHLY_SAVINGS: 'Avg Monthly Savings'
} as const;

export const TRADE_IN_TITLE_PREFIX = 'Trade In';

export const TRADE_IN_LABELS = {
    TOTAL_ALLOWANCE: 'Total Trade Allowance:',
    TOTAL_ADJUSTMENTS: 'Total Trade Adjustments:',
    TAX_SAVINGS: 'Trade Tax Savings:',
    EFFECTIVE_ALLOWANCE: 'Effective Trade Allowance:'
} as const;

export const CUSTOMER_CONTACT_SEPARATOR = ' | ';
